export const CLICKABLE_ROW_TEST_ID = 'clickable-row'
